// ─── Changelog Selah ─────────────────────────────────────────────────────────
// Affiché dans ChangelogModal après chaque mise à jour.
// La modal s'affiche tant que `localStorage['selah_last_seen_version']` ne
// correspond pas à `changelog.version`. Bumper `version` à chaque release.

export interface ChangelogItem {
  icon: string
  title: string
  description: string
}

export interface ChangelogEntry {
  version: string
  title: string
  items: ChangelogItem[]
}

export const changelog: ChangelogEntry = {
  version: '1.18.0',
  title: 'Groupes — Priez ensemble',
  items: [
    {
      icon: 'users',
      title: 'Groupes de priere',
      description:
        'Cree ou rejoins un groupe pour partager tes prieres et objectifs avec un cercle de confiance. Limite a 20 personnes pour commencer.',
    },
    {
      icon: 'hand',
      title: 'Je prie / Je soutiens',
      description:
        "Montre a quelqu'un que tu pries pour lui ou que tu le soutiens dans ses objectifs.",
    },
    {
      icon: 'star',
      title: 'Memorial des exaucements',
      description:
        'Retrouve toutes les prieres exaucees de ton groupe dans un espace dedie.',
    },
    {
      icon: 'bell',
      title: 'Notifications push',
      description:
        "Recois une notification quand quelqu'un rejoint ton groupe ou interagit avec tes prieres.",
    },
  ],
}

export const LAST_SEEN_VERSION_KEY = 'selah_last_seen_version'
